<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Listagem de Pins e Trocas
      </p>
    </div>
    <table-pins />
  </q-page>
</template>

<script>
import TablePins from "../components/TablePins.vue";
export default {
  components: { TablePins },
  setup() {
    return {};
  },
};
</script>
